import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Typography, Button, Card, Box, InputAdornment, TextField } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import Pagination from '@mui/material/Pagination';
import Avatar from '@mui/material/Avatar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import LinearProgress from '@mui/material/LinearProgress';
import { debounce, throttle } from 'lodash';
const SwitchAgent = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [switchAgent, setSwitchAgent] = useState([]);
    const [AllSwitchAgent, setAllSwitchAgent] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const abortControllerRef = useRef(null);
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };
    const handleClear = () => {
        setSearchTerm('');
        setCurrentPage(1);
        fetchSwitchAgent(1, '');
    };
    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const columns = [
        {
            accessorKey: 'agent_id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 20,
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.agent?.profile_image} />
                </div>
            ),
            size: 20,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.agent?.last_name === null) {
                    return row?.agent?.name;
                } else {
                    return `${row?.agent?.name} ${row?.agent?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 80,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.agent?.email) {
                    return `${row?.agent?.email}`;

                }
            },
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorFn: (row) => {
                if (row?.agent?.phone) {
                    return `${row?.agent?.phone}`;

                }
            },
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
        },

        {
            accessorKey: 'created_at',
            header: 'Switch Date',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'deleted_at',
            header: 'Deleted at',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const dateString = row?.original?.agent?.deleted_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'last_login',
            header: 'Last Login ',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const dateString = row?.original?.agent?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return "Never Logged In";
            },
        },

        {
            id: 'actions',
            accessorKey: 'SeeMore',
            header: 'See More',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const handleViewClick = () => {
                    navigate(`/switch-agent-details/${row?.original?.id}`);
                };

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IconButton aria-label="view" onClick={handleViewClick}>
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                );
            },
        },
    ]
    const getSwitchAgents = async (currentPage, searchTerm = '', signal) => {

        try {
            setLoading(true)
            const res = await LeadService.GetShiftedOrganizationAgent(currentPage, searchTerm, { signal });
            if (res?.data?.success) {
                setSwitchAgent(res?.data?.data?.data);
                setAllSwitchAgent(res?.data?.total_shifted_agents);
                setCurrentPage(res?.data?.data?.current_page);
                setTotalPages(Math.ceil((res?.data?.data?.total) / (res?.data?.data?.per_page)));
                return;
            }

        } catch (error) {
            toast.error(error.message)
            console.error(error);
        } finally {
            setIsLoading(false);
            setLoading(false)

        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledGetSwitchAgents = useCallback(
        throttle((page, searchTerm, signal) => {
            getSwitchAgents(page, searchTerm, signal);
        }, 2000), []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchSwitchAgent = useCallback(
        debounce((page, searchTerm) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetSwitchAgents(page, searchTerm, abortController.signal);
        }, 300), [throttledGetSwitchAgents]
    );

    useEffect(() => {
        fetchSwitchAgent(currentPage, searchTerm);
    }, [currentPage, searchTerm, fetchSwitchAgent]);

    return (
        <div>
            <ScrollAnimation animateIn="fadeIn">
                <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
                <Card
                    variant="outlined"
                    sx={{
                        borderRadius: '22px',
                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                        background: '#ebebeb',
                        width: '250px',
                        transform: 'scale(1)',
                        transition: 'transform 0.3s ease-in-out',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                    <Box style={{ margin: '10px', padding: '14px' }}>
                        <div>
                            <Typography style={{ fontSize: '66px', fontWeight: '700' }}>{AllSwitchAgent}</Typography>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <PersonIcon sx={{ color: '#5379BD' }} />
                            <Typography style={{ fontSize: '14px', color: '##3a5696', fontFamily: 'monospace', marginTop: '5px', marginLeft: '5px' }}>
                                Total Number Switch Request
                            </Typography>
                        </div>
                    </Box>
                </Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                    <div>
                        <Typography style={{ fontSize: '36px', fontWeight: '700' }}>Switch Request</Typography>
                    </div>
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                        <TextField
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search name, email"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClear}
                                            aria-label="clear search"
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                        />
                    </Box>
                </div>

                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                                height: '14px'
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />
                    <div style={{ width: '100%', overflow: 'visible' }}>
                        <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                            <MaterialReactTable
                                columns={columns}
                                data={switchAgent}
                                state={{ isLoading: isLoading }}
                                muiCircularProgressProps={{
                                    color: 'secondary',
                                    thickness: 5,
                                    size: 55,
                                }}
                                muiSkeletonProps={{
                                    animation: 'pulse',
                                    height: 28,
                                }}
                                enablePagination={false}
                                enableTopToolbar={true}
                                enableDensityToggle={false}
                                enableHiding={false}
                                showSkeletons={false}

                                enableColumnFilterModes={false}
                                enableColumnActions={false}
                                enableColumnOrdering={false}
                                enableFullScreenToggle={false}
                                enableColumnFilters={false}
                                enableGlobalFilter={false}
                                initialState={{
                                    showColumnFilters: false,
                                    showGlobalFilter: false,
                                }}
                            />
                        </Card>

                        <Pagination
                            count={totalPages}
                            color="primary"
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                        />
                    </div>
                </ThemeProvider>
            </ScrollAnimation>
        </div>
    );
};

export default SwitchAgent;
